import * as commonScripts from '../common'
const cmpPodcastStandard = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
  }
}

export default cmpPodcastStandard
